import { render, staticRenderFns } from "./editgoods.vue?vue&type=template&id=9a9fe99e&scoped=true&"
import script from "./editgoods.vue?vue&type=script&lang=js&"
export * from "./editgoods.vue?vue&type=script&lang=js&"
import style0 from "./editgoods.vue?vue&type=style&index=0&id=9a9fe99e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9fe99e",
  null
  
)

export default component.exports